import "./PageLoading.scss";

/** Centered loading indicator for backoffice pages. */
export function PageLoading() {
  return (
    <p className="page-loading" role="status" aria-live="polite">
      Cargando...
    </p>
  );
}
